import React from "react";
import { TooltipContent, TooltipPortal, TooltipRoot, TooltipTrigger } from "src/components/ui/tooltip";

type InvalidFieldTooltipPropsType = {
  invalid: boolean;
  message: string;
  children: React.ReactNode;
};

export function InvalidFieldTooltip({ invalid, message, children }: InvalidFieldTooltipPropsType) {
  return (
    <TooltipRoot open={invalid}>
      <TooltipTrigger asChild>{children}</TooltipTrigger>
      <TooltipPortal>
        <TooltipContent side="top" className="text-red-500 border-red-500/50">
          {message}
        </TooltipContent>
      </TooltipPortal>
    </TooltipRoot>
  );
}
